<template>
  <v-list-tile
    :class="`bg-${value.status}`"
    style="border-radius: 8px; height: 100%"
    class="mb-1 follow-up-item"
  >
    <v-list-tile-content style="padding: 4px 0">
      <v-list-tile-title
        >{{ value.first_name }} {{ value.last_name }}

        <span
          v-if="value.start_time && value.end_time"
          style="font-size: 13px"
          class="text--primary ml-1"
        >
          ({{ formattedTime }})
        </span>
      </v-list-tile-title>
      <v-list-tile-sub-title
        ><ChannelLabel :channel="value.app">
          <template #channel="{ channelColor, selectedChannel }">
            <span v-if="selectedChannel" :style="{ color: channelColor }">
              <em v-if="selectedChannel.icon" :class="selectedChannel.icon" />
              {{ selectedChannel.text }}
            </span>
          </template>
        </ChannelLabel></v-list-tile-sub-title
      >

      <v-list-tile-sub-title v-if="value.sub_status">
        <v-chip small color="#B6D0E2" text-color="#333">
          {{ $t(`follow_up.status.${value.sub_status}`) }}</v-chip
        >
      </v-list-tile-sub-title>

      <v-list-tile-sub-title>
        <span class="text--primary"
          >{{ value.title }}
          <span v-if="!hideAction"> - {{ value.details }}</span>
        </span>
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action v-if="!hideAction">
      <v-btn icon color="primary" @click.stop="handleGoToLiveChat">
        <v-icon small>chat</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { mapGetters } from 'vuex'
import ChannelLabel from '@/components/elements/ChannelLabel'
import dayjs from 'dayjs'

export default {
  components: {
    ChannelLabel
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    hideAction: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    formattedTime() {
      if (this.value.start_time && this.value.end_time) {
        return [
          dayjs(this.value.start_time).format('HH:mm'),
          dayjs(this.value.end_time).format('HH:mm')
        ].join(' - ')
      }

      return ''
    }
  },

  methods: {
    handleGoToLiveChat() {
      let routeData = this.$router.resolve({
        name: 'allinonechat-new',
        path: '/' + this.currentLang + '/allinonechat-new',
        query: {
          search: this.value.user_id,
          inbox: 'all',
          app: this.value.app
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-pending {
  background-color: #ffecb3;
}
.bg-in_progress {
  background-color: #f0b582;
}
.bg-complete {
  background-color: #c1e1c1;
}
.bg-cancel {
  background-color: #ffd4d3;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/Kmb/FollowUp/FollowUpTaskItem.vue